import React from "react";
import BasicModal from "../../../core/BaseComponents/Modal";


const ChangePasswordConfirmPopUp = (props) => {
    return (
        <BasicModal
            popupOpen={props?.modalOpen}
            bodyMessage={<p>Do you really want to Change Password, This will Logout You From Application?</p>}
            logo={"/Images/change-password.png"}
            footer={{
                primaryButton: {
                    action: props?.modalClose,
                    buttonName: "Cancel"
                },
                secondaryButton: {
                    action: props?.modalConfirm,
                    buttonName: "Yes"
                },
            }}
        />
    )
}

export default ChangePasswordConfirmPopUp